import styles from './IconCta.module.scss';
import { Link } from '@/components/Link';
import { RouteType } from '@/util/routeToPath';
import { usePrefetchQuery } from '@/hooks/usePrefetchQuery';
import { ReactNode, MouseEventHandler } from 'react';

type Props = {
  to: RouteType;
  prefetchQuery?: () => void;
  icon: ReactNode;
  title: string;
  description: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  unseenCount?: number;
};

const noop = () => {
  // ignore.
};

export function IconCta({
  to,
  title,
  description,
  prefetchQuery = noop,
  icon,
  onClick,
  unseenCount = 0,
}: Props) {
  const ref = usePrefetchQuery<HTMLAnchorElement>(prefetchQuery);

  return (
    <Link ref={ref} to={to} className={styles.IconCta} onClick={onClick}>
      {icon}
      <div>
        <h3>
          {title} {unseenCount > 0 && <span>{unseenCount}</span>}
        </h3>
        <p>{description}</p>
      </div>
    </Link>
  );
}
